<template>
  <div class="modal-produto" v-if="aberto">
    <div id="modalProdutoContent" class="modal-produto-content" tabindex="1">
      <div class="header-produto py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center">
          <div class="position-relative">
            <a href="javascript:" @click="previusStep(true)" class="btn btn-outline-light btn-voltar-round position-absolute" style="left: 0; top: -9px" aria-label="Voltar">
              <i class="fa fa-chevron-left text-dark"></i>
            </a>
            <h1 class="h6 font-weight-bold m-auto" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
              <span :class="{'text-white': load}">{{produto.nome_produto ? produto.nome_produto : ' - '}}</span>
            </h1>
            <a href="javascript:" @click="closeProduto(true)" class="btn btn-outline-light btn-voltar-round position-absolute" style="right: 0; top: -9px" aria-label="Voltar" v-show="step > 1">
              <i class="fa fa-times text-dark"></i>
            </a>
          </div>
        </div>
      </div>
      <div id="containerProduto" class="container-produto">
        <loading v-show="load" class="mt-4"/>
        <div class="row no-gutters" v-if="!load && produto.tabelas">
          <div class="col-md-6 d-md-block my-3" v-show="step === stepImg">
            <div class="container" style="position: sticky; top: 16px">
              <produto-descricao :produto="produto" @modalImage="$emit('modalImage', $event)"/>
            </div>
          </div>
          <div class="col-md-6">
            <div v-if="produto.tabelas.length > 1" v-show="step === 0">
              <div class="bg-gray">
                <div id="tabelaProduto" class="container" style="position: relative">
                  <div class="d-flex justify-content-between py-4">
                    <h6 class="mb-0">Selecione uma opção:</h6>
                    <i class="fa fa-check text-primary icon-check" v-show="dados.produto.id_tabela_preco"></i>
                    <span class="badge badge-primary float-right" v-show="!dados.produto.id_tabela_preco">Obrigatório</span>
                  </div>
                </div>
              </div>
              <div class="container px-0">
                <div class="lista-produto" :class="{'produto-disable': parseInt(t.qtd_estoque) <= 0, 'produto-selecionado': t.id_tabela_preco === dados.produto.id_tabela_preco}"
                     v-for="t in produto.tabelas" @click="selecionarTamanho(t)">
                  <div class="col lista-produto-item">
                    <div>
                      <h6 class="m-0" style="font-size: 16px">{{t.nome_tabela}}</h6>
                      <p class="tamanho-2 text-muted font-weight-bold m-0" v-if="t.valor > 0">
                        <span v-show="t.valor_base > 0 && t.valor_base > t.valor">De: <del class="text-danger pr-1"> {{t.valor_base | valor}}</del> por:</span>
                        <span class="mt-2 valor" v-show="t.valor > 0"> {{t.valor | valor}}</span>
                      </p>
                      <div>
                          <span class="badge badge-light font-weight-normal" v-if="t.turnos && t.disponivel === '0'">
                            <i class="fa fa-clock-o text-primary"></i> Disponível das <b class="text-primary">{{t.turnos}}</b>
                          </span>
                        <span class="badge border border-secondary text-secondary" v-else-if="t.qtd_estoque <= 0">sem estoque</span>
                        <produto-consumo :consumo="t.tipo_consumo" :tipo_pedido="sacola.tipo_pedido" v-else/>
                        <produto-modo-pedido class="ml-1" :modo-pedido="t.modo_pedido"/>
                      </div>
                    </div>
                  </div>
                  <div class="pr-2 text-right">
                    <indicador-selecao :selecionado="t.id_tabela_preco === dados.produto.id_tabela_preco"/>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="produto.divisao > 0 && produto.divisoes.length > 0" v-show="step === 1">
              <div id="produtoDivisao" class="bg-gray topbar-produto">
                <div class="container">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-0">Selecione {{produto.divisao > 1 ? 'os' : 'o'}} sabor{{produto.divisao > 1 ? 'es' : ''}}</h6>
                      <span>{{dados.divisoes.length}} de {{produto.divisao}}</span>
                    </div>
                    <div>
                      <span class="badge badge-primary float-right" v-show="dados.divisoes.length === 0">Obrigatório</span>
                      <i class="fa fa-check text-primary icon-check" v-show="dados.divisoes.length === parseInt(produto.divisao)"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container px-0">
                <div v-show="produto.divisoes.length > 6" v-if="step === 1">
                  <div class="d-flex justify-content-between border-bottom pb-3 mt-3 px-2">
                    <VueFuse :list="produto.divisoes" :fuse-opts="options" :map-results="true" placeholder="Pesquisar sabor.."
                             class="form-control mr-2" ref="fuseDivisao" @fuse-results="handleResult"/>
                    <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
                  </div>
                </div>
                <div class="lista-produto" v-for="d in searchDivisao" v-show="(d.id_tabela === dados.produto.id_tabela) || !dados.produto.id_tabela"
                     @click="selecionarDivisao(d)" :class="{'produto-disable' : !dados.produto.id_tabela, 'produto-selecionado': dados.divisoes.find(div => div.id_tabela_preco === d.id_tabela_preco)}">
                  <div class="col lista-produto-item">
                    <div class="mr-2">
                      <img
                        :src="d.url_imagem"
                        :alt="d.nome_produto"
                        :aria-label="'Ampliar foto de ' + d.nome_produto"
                        class="pointer"
                        role="button"
                        tabindex="0"
                        v-if="d.url_imagem"
                        @click.stop="$emit('modalImage', d.url_imagem)"
                        @keydown.enter.stop.prevent="$emit('modalImage', d.url_imagem)"
                        @keydown.space.stop.prevent="$emit('modalImage', d.url_imagem)"
                      />
                    </div>
                    <div>
                      <h6 class="mt-0 mb-1" style="font-size: 16px">{{d.nome_produto}}</h6>
                      <p class="m-0 text-muted tamanho-2">
                        <span class="mb-1" v-if="d.descricao_produto">{{d.descricao_produto}} <br></span>
                        <span v-show="d.valor_base > 0 && d.valor_base > d.valor">De: <del class="text-danger pr-1"> {{d.valor_base | valor}}</del> por: </span>
                        <span class="mt-2 text-dark font-weight-bold" v-if="d.valor > 0">{{d.valor | valor}}</span>
                        <span class="produto-divisao-restricoes">
                          <produto-tag :id-tag="d.id_tag" variant="compacta"/>
                          <produto-consumo :consumo="d.tipo_consumo" :tipo_pedido="sacola.tipo_pedido"/>
                          <produto-modo-pedido :modo-pedido="d.modo_pedido"/>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="pr-2 text-right">
                    <indicador-selecao :selecionado="Boolean(dados.divisoes.find(div => div.id_tabela_preco === d.id_tabela_preco))"/>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="produto.adicionais && produto.adicionais.length">
              <div v-for="(g, index) in produto.adicionais" v-show="step === (index + 2)" :id="'grupoAdicional' + index">
                <div class="bg-gray topbar-produto border-bottom pointer">
                  <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="mb-0">{{g.nome_grupo}}</h6>
                        <div class="small font-weight-bold" v-if="g.qtd_min > 0 || g.qtd_max > 0">
                          <span v-if="g.qtd_min > 0">Mínimo {{g.qtd_min}}</span>
                          <span v-if="g.qtd_min > 0 && g.qtd_min < g.qtd_max"> e </span>
                          <span v-if="g.qtd_min < g.qtd_max">Máximo {{g.qtd_max}}</span>
                          <div v-if="g.qtd_sel !== '1'"> ({{g.selecionados}} de {{g.qtd_max}})</div>
                        </div>
                      </div>
                      <div>
                        <div class="text-center">
                          <span class="badge badge-secondary" v-if="g.qtd_min === '0'">Opcional</span>
                          <span class="badge badge-primary" v-else-if="g.qtd_min > 0 && !(g.selecionados >= g.qtd_min)">Obrigatório</span>
                          <i class="fa fa-check text-primary icon-check" v-show="g.qtd_min > 0 && g.selecionados >= g.qtd_min"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container px-0">
                  <div class="mt-3 border-bottom px-2" v-show="g.itens.length > 8" v-if="step === (index + 2)">
                    <div class="d-flex justify-content-between mb-3">
                      <VueFuse :list="g.itens" :fuse-opts="options" :map-results="true" placeholder="Pesquisar adicional.."
                               class="form-control mr-2" @fuse-results="handleAdicional" @fuse-input="(res) => termAdd = res" id="searchAdd"/>
                      <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                  <div class="lista-produto" v-for="a in searchAdicional" :class="{'produto-disable': parseInt(a.qtd_estoque) <= 0, 'produto-selecionado': a.qtd > 0}">
                    <div class="col lista-produto-item" @click="toggleAdicionais(g, a, index)">
                      <div class="mr-2">
                        <img :src="a.url_imagem" :alt="a.nome_produto" v-if="a.url_imagem"/>
                      </div>
                      <div>
                        <h6 class="m-0" style="font-size: 16px">{{a.nome_produto}}</h6>
                        <p class="text-muted m-0 tamanho-2">
                          <span class="d-block" v-if="g.max_item === '1'">Máximo 1</span>
                          <span v-if="a.descricao_produto" v-html="a.descricao_produto"></span>
                          <span class="font-weight-bold text-dark d-block" v-if="a.valor > 0">+ {{(a.valor * g.qtd_sel) | valor}}</span>
                          <produto-consumo :consumo="a.tipo_consumo" class="mt-1"/>
                          <produto-modo-pedido class="mt-1" :modo-pedido="a.modo_pedido"/>
                        </p>
                        <div class="small" v-if="a.qtd_estoque <= 20">
                          <span class="badge badge-secondary" v-if="a.qtd_estoque <= 0">Sem estoque</span>
                          <span v-else-if="a.qtd_estoque == 1">Última unidade disponível</span>
                          <span v-else><b>{{a.qtd_estoque | percent}}</b> unidades disponíveis</span>
                        </div>
                      </div>
                    </div>
                    <div style="width: 110px">
                      <div class="pr-2 text-right" v-if="g.qtd_max === '1'" @click="toggleAdicionais(g, a, index)">
                        <indicador-selecao :selecionado="a.qtd > 0"/>
                      </div>
                      <div class="box-qtd" v-else>
                        <button type="button" class="btn botao-qtd" @click="removeAdicionais(g, a, index)"
                                :class="{'disabled' : parseInt(a.qtd) === 0}">
                          <i class="fa fa-minus"></i>
                        </button>
                        <div class="qtd-output text-dark"><b>{{a.qtd}}</b></div>
                        <button type="button" class="btn botao-qtd" @click="addAdicionais(g, a, index)"
                                :class="{'disabled' : a.qtd == parseInt(a.qtd_estoque) || (g.max_item === '1' && a.qtd)}">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="observacaoProduto" class="container" :class="{'mt-3': step !== stepImg}" v-show="step === maxStep">
              <aviso-informativo title="Não estamos atendendo!" class="mb-3 mt-md-3" v-if="!empresaAberta">
                <p class="small m-0">Fique à vontade para olhar nossos produtos.</p>
              </aviso-informativo>
              <div class="d-flex justify-content-between align-items-center mb-3" v-else-if="step !== stepImg">
                <div>Resumo</div>

              </div>
              <div class="py-3 mb-1 border-top" v-if="dados.produto">
                <p class="mb-0"><b>{{dados.quantidade}}x</b>
                  - {{produto.nome_produto}}
                  <span class="small" v-if="dados.produto.nome_tabela">({{dados.produto.nome_tabela}})</span>
                </p>
                <p v-for="d in dados.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</p>
                <p v-for="d in dados.adicionais" class="m-0 pl-2 tamanho-2">
                  + <span v-show="d.qtd > 1">{{d.qtd}}x</span>
                  {{d.nome_produto}} <span v-show="d.valor > 0"> <b>{{((d.valor * d.qtd) * dados.quantidade) | valor}}</b></span>
                </p>
                <p class="mt-1 mb-0 tamanho-1" v-if="!beneficio">Total: <b>{{(dados.valor * dados.quantidade) | valor}}</b></p>
              </div>
              <div v-if="empresaAberta">
                <div class="card card-quantidade px-2 py-3 mb-4" v-if="dados.produto && !beneficio">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="m-0 font-weight-bold">Quantidade</h6>
                      <div class="small" v-if="dados.produto.estoque === '1'">
                        <span v-if="dados.produto.qtd_estoque == 1">1 unidade disponível</span>
                        <span v-else-if="dados.produto.qtd_estoque <= 20"><b>{{dados.produto.qtd_estoque | percent}}</b> unidades disponíveis</span>
                      </div>
                    </div>
                    <div style="width: 125px;">
                      <quantidade @change="mudarQtd" :max="dados.produto.qtd_estoque"/>
                    </div>
                  </div>
                </div>
                <div v-if="empresa.json_config.obs_produto === '1'">
                  <label class="h6 mb-2" for="observacoes">Observações <span class="small text-muted font-weight-normal ml-1">(opcional)</span></label>
                  <textarea class="form-control observacoes-produto" id="observacoes" rows="3" placeholder="Exemplo: Retirar um ingrediente"
                            style="resize: none" v-model="dados.observacao"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top add-sacola">
        <div class="row no-gutters align-items-center">
          <div class="col-4 col-md-6 font-weight-bold" style="font-size: 1.1em">
            <span class="badge badge-warning text-white" v-if="beneficio"><icon name="pontos" size="12" class="mr-1"/> Benefício</span>
            <span v-else-if="dados.valor > 0">{{(dados.valor * dados.quantidade) | valor}}</span>
            <span class="text-muted" v-else>R$ 0,00</span>
          </div>
          <div class="col-8 col-md-6">
            <div v-if="step === maxStep">
              <button class="btn btn-primary btn-block btn-bottom" @click="adicionarSacola()" :disabled="!empresaAberta" v-if="beneficio">Resgatar</button>
              <button class="btn btn-primary btn-block btn-bottom" @click="adicionarSacola()" :disabled="!empresaAberta" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" id="Bold" class="fi" viewBox="0 0 24 24" width="16" height="16" fill="#ffffff"><circle cx="7" cy="22" r="2"/><circle cx="17" cy="22" r="2"/><path d="M19.75,13.162A2.5,2.5,0,0,1,17.339,15H7.217a.329.329,0,0,1-.325-.3L6.036,8H10.5A1.5,1.5,0,0,0,12,6.5h0A1.5,1.5,0,0,0,10.5,5H5.653L5.391,2.939A3.327,3.327,0,0,0,2.087,0H1.5a1.5,1.5,0,0,0,0,3h.587a.329.329,0,0,1,.325.3l1.5,11.76A3.327,3.327,0,0,0,7.217,18H17.339a5.5,5.5,0,0,0,5.3-4.042l.016-.06A1.5,1.5,0,0,0,21.213,12h0a1.5,1.5,0,0,0-1.446,1.1Z"/><path d="M22.5,3H21V1.5a1.5,1.5,0,0,0-3,0V3H16.5a1.5,1.5,0,0,0,0,3H18V7.5a1.5,1.5,0,0,0,3,0V6h1.5a1.5,1.5,0,0,0,0-3Z"/></svg>
                <span class="ml-1">Adicionar</span>
              </button>
            </div>
            <button class="btn btn-primary btn-block btn-bottom" :disabled="btnAvancar < step" @click="nextStep(true)" v-else>
              Avançar <i class="fa fa-chevron-right ml-1" style="font-size: 14px"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import AvisoInformativo from './AvisoInformativo';
  import Loading from './Loading'
  import Quantidade from './Quantidade';
  import CardInfo from "./CardInfo";
  import Icon from "./Icon";
  import VueFuse from 'vue-fuse'
  import ProdutoDescricao from "./ProdutoDescricao";
  import ProdutoConsumo from "./ProdutoConsumo";
  import ProdutoModoPedido from "./ProdutoModoPedido";
  import ProdutoTag from "./ProdutoTag";
  import IndicadorSelecao from "./IndicadorSelecao";

  export default {
    name: "Produto",
    props: ['categoria','empresaAberta','beneficio','isComponente'],
    components: {AvisoInformativo, IndicadorSelecao, ProdutoTag, ProdutoModoPedido, ProdutoConsumo, ProdutoDescricao, Icon, CardInfo, Quantidade, Loading, VueFuse},
    data() {
      return {
        aberto: false,
        btnAvancar: false,
        avancar: true,
        fixo: true,
        produto: {},
        adicionais: [],
        total: 0,
        load: true,
        dados: {
          produto: {},
          adicionais: [],
          valor: 0,
          divisoes: [],
          quantidade: 1,
          observacao: ''
        },

        step: 0,
        stepImg: 0,
        maxStep: 6,

        termAdd: '',
        options: {
          shouldSort: true,
          threshold: 0.3,
          location: 0,
          distance: 100,
          minMatchCharLength: 1,
          keys: ["nome_produto", "descricao_produto", "nome_tabela"]
        },
        searchDivisao: [],
        searchAdicional: []
      }
    },

    methods: {
      getProduto(id, tabela) {
        this.fixo = !!tabela;
        this.avancar = true;
        this.btnAvancar = -1;
        this.step = 0;
        this.total = 0;
        this.produto = {};
        this.adicionais = [];
        this.dados = {
          id_produto: id,
          produto: {},
          adicionais: [],
          valor: 0,
          divisoes: [],
          quantidade: 1,
          observacao: ''
        };

        document.body.classList.add("modal-open");
        this.aberto = true;
        this.load = true;
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.get(url + 'v2/produto/' + id, { params: {tipo_pedido: this.sacola.tipo_pedido} })
          .then(response => {
            if (!response.data.id_produto) {
              this.load = false;
              this.$swal('Não conseguimos carregar as informações deste produto.\nTente novamente mais tarde!')
              this.closeProduto();
              return;
            }

            this.produto = response.data;
            this.maxStep = this.produto.adicionais.length + 2;
            this.stepImg = this.produto.tabelas.length > 1 ? 0 : (this.produto.divisoes.length > 0 ? 1 : 2);

            if (tabela) {
              tabela = this.produto.tabelas && this.produto.tabelas.find(p => p.id_tabela_preco === tabela);

              if (!tabela) {
                this.$swal('Este produto está indisponível no momento');
                this.$emit('retorno');
                this.closeProduto();
                return;
              }
            }

            const tabelaInicial = tabela || (this.produto.tabelas && this.produto.tabelas.length === 1 ? this.produto.tabelas[0] : null);

            if (tabelaInicial) {
              if (this.selecionarTamanho(tabelaInicial) === false) {
                this.stepImg = 0;
              } else {
                this.nextStep(false);
              }
            }

            this.$helpers.trackPixel(this, 'ViewContent', this.empresa, true, {
              content_name: this.produto.nome_produto,
              content_category: this.produto.nome_categoria,
              content_ids: [this.produto.id_produto],
              content_type: 'product'
            });

            this.load = false;

          }, res => {
            this.load = false;
            this.closeProduto();
            this.$swal(res.data.msg || "Não conseguimos carregar as informações deste produto.\nTente novamente mais tarde!");
          });
      },

      handleResult(r) {
        this.searchDivisao = r;
      },

      handleAdicional(r) {
        this.searchAdicional = r;
      },

      limparAdicional(adicionais) {
        this.termAdd = "";
        this.$store.state.load = false;
        this.searchAdicional = adicionais;
        const input = document.getElementById("searchAdd");

        if (input) {
          input.value = "";
          this.$helpers.focusrElement('searchAdd');
        }
      },

      selecionarDivisaoValor(somar) {
        let valor = 0;
        if (this.dados.divisoes.length > 0) {
          //venda fracionada
          if (this.produto.tipo_venda === '2') {
            this.dados.divisoes.forEach((d) => {
              valor += parseFloat(d.valor);
            });

            valor = valor / this.dados.divisoes.length;

          } else {
            this.dados.divisoes.forEach((d) => {
              if (valor < parseFloat(d.valor)) {
                valor = parseFloat(d.valor);
              }
            });
          }

          if (somar) {
            this.dados.valor += valor;

          } else {
            this.dados.valor -= valor;
          }
        }
      },

      selecionarDivisao(d) {
        if (this.dados.produto.id_tabela) {
          const divisaoQtd = parseInt(this.produto.divisao);
          let divisao = this.dados.divisoes.find(div => div.id_tabela_preco === d.id_tabela_preco);

          if (!divisao && (this.dados.divisoes.length !== divisaoQtd || divisaoQtd === 1)) {
            this.selecionarDivisaoValor(false);

            if (divisaoQtd === 1) {
              this.dados.divisoes = [];
            }

            this.dados.divisoes.push({
              id_produto: d.id_produto,
              id_tabela: d.id_tabela,
              id_tabela_preco: d.id_tabela_preco,
              nome_produto: d.nome_produto,
              ref_produto: d.ref_produto,
              tipo_consumo: d.tipo_consumo,
              modo_pedido: d.modo_pedido || '1',
              valor: d.valor,
              valor_base: d.valor_base,
              pontos: d.pontos || 0,
            });

            this.selecionarDivisaoValor(true);

          } else if (divisao) {
            this.selecionarDivisaoValor(false);
            this.dados.divisoes = this.dados.divisoes.filter(div => div.id_tabela_preco !== d.id_tabela_preco);
            this.selecionarDivisaoValor(true);

          } else {
            this.$swal('Máximo de sabor permitido: ' + this.produto.divisao + '');
            return;
          }

          this.btnAvancar = (this.dados.divisoes.length === parseInt(this.produto.divisao)) ? 1 : 0;

          if (this.btnAvancar === 1) {
            this.animateCSS('btnAvancar', 'bounceIn');

            if (this.dados.divisoes.length === parseInt(this.produto.divisao)) {
              this.avancarAutomatico();
            }
          }

        } else {
          this.$swal('Selecione um item antes de selecionar o sabor');
        }
      },

      selecionarTamanho(t) {
        if (t.estoque === '1' && parseInt(t.qtd_estoque) <= 0) {
          this.$swal('Sem estoque', 'Este produto está indisponível no momento');
          return false;
        }

        this.selecionarDivisaoValor(false);
        this.dados.divisoes = [];

        if (t.id_tabela_preco === this.dados.produto.id_tabela_preco) {
          this.dados.produto = {};
          this.dados.valor -= parseFloat(t.valor);
          this.btnAvancar = -1;

        } else {
          if (this.dados.produto.valor) {
            this.dados.valor -= parseFloat(this.dados.produto.valor);
          }

          this.dados.produto = t;
          this.dados.valor += parseFloat(t.valor);
          this.btnAvancar = 0;

          if (this.dados.produto.turnos && this.dados.produto.disponivel === '0') {
            this.$swal('Disponibilidade', 'Este produto está disponível para pedidos somente das: ' + this.dados.produto.turnos + '.');

          } else if (this.produto.tabelas.length > 1 && !this.fixo) {
            this.animateCSS('btnAvancar', 'bounceIn');
            this.avancarAutomatico("Selecionando..");
          }

          this.$helpers.trackAnalytics("view_item", {
            currency: "BRL",
            value: parseFloat(t.valor),
            items: [{
              item_id: t.id_tabela_preco,
              item_name: this.produto.nome_produto
            }]
          });
        }
      },

      removeAdicionais(g, a, index) {
        const qtd_sel = parseInt(g.qtd_sel || '1');
        let adicional = this.dados.adicionais.find(obj => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

        if (adicional) {
          const qtd = (parseInt(adicional.qtd) - qtd_sel);

          if (qtd <= 0) {
            this.dados.adicionais = this.dados.adicionais.filter(obj => obj !== adicional);
          }

          adicional.qtd = qtd;
          g.selecionados = (g.selecionados - qtd_sel);
          this.dados.valor -= (parseFloat(a.valor) * qtd_sel);
          this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));
        }
      },

      addAdicionais(g, a, index) {
        if (!(g.qtd_max > 0 && parseInt(g.qtd_max) === parseInt(g.selecionados))) {
          const qtd_sel = parseInt(g.qtd_sel || '1');
          let adicional = this.dados.adicionais.find(obj => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

          if (parseInt(a.qtd_estoque) <= ((adicional ? adicional.qtd : 0) + qtd_sel)) {
            this.$swal('Estoque insuficiente');
            return;
          }

          if (!adicional) {
            a.qtd = qtd_sel;
            a.index = index;
            a.id_grupo = g.id_grupo;
            this.dados.adicionais.push(a);

          } else if (g.max_item === '1') {
            this.$swal('Máximo 1');
            return;

          } else {
            adicional.qtd = (adicional.qtd + qtd_sel);
          }

          g.selecionados = (parseInt(g.selecionados) + qtd_sel);
          this.dados.valor += (parseFloat(a.valor) * qtd_sel);
          this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));

          if (g.selecionados === parseInt(g.qtd_max)) {
            this.avancarAutomatico();

          } else if (this.termAdd.trim()) {
            this.$store.state.load = "Aguarde..";
            setTimeout(() => {
              this.limparAdicional(g.itens);
            }, 800);
          }

        } else {
          this.$swal("A quantidade máxima para o adicional \"" + g.nome_grupo + "\" é: " + g.qtd_max);
        }
      },

      toggleAdicionais(g, a, index) {
        if (g.qtd_max === '1') {
          const add = this.dados.adicionais.find(g => g.id_grupo_adicional === a.id_grupo_adicional);

          if (!add) {
            this.addAdicionais(g, a, index);

          } else {
            this.removeAdicionais(g, add, index);

            if (a !== add) {
              this.addAdicionais(g, a, index);
            }
          }

        } else {
          if (a.qtd > 0) {
            this.removeAdicionais(g, a, index);

          } else {
            this.addAdicionais(g, a, index);
          }
        }
      },

      validarBtnAdicionar() {
        let tabelaExiste = this.dados.produto.id_tabela_preco;

        let valido = true;
        this.produto.adicionais.forEach((g) => {
          if (g.qtd_min > 0 && g.selecionados < parseInt(g.qtd_min)) {
            valido = false;
          }
        });

        let divisao = (this.dados.divisoes.length === parseInt(this.produto.divisao)) || this.produto.divisoes.length === 0;
        return (tabelaExiste && valido && divisao);
      },

      mudarQtd(qtd) {
        this.dados.quantidade = qtd;
      },

      adicionarSacola() {
        if (!this.validarBtnAdicionar()) {
          return;
        }

        if (this.dados.valor <= 0) {
          this.$swal('Este produto está disponível apenas para valores maiores que R$ 0,00');
          return;
        }

        if (this.dados.produto.turnos && this.dados.produto.disponivel === '0') {
          this.$swal('Disponibilidade', 'Este produto está disponível para pedidos somente das: ' + this.dados.produto.turnos + '.');
          return;
        }

        if (this.beneficio) {
          this.$emit('retorno', this.dados);
          this.closeProduto();
          return;
        }

        const sacola = this.$store.state.sacola || { produtos: [] };
        sacola.produtos.push(this.dados);
        this.$store.commit('setProdutosSacola', sacola);
        this.closeProduto();

        // eventos
        this.$helpers.trackPixel(this, 'AddToCart', this.empresa);
        this.$helpers.googleTag(this, '2');
        this.$helpers.trackAnalytics('add_to_cart', {
          currency: "BRL",
          value: (this.dados.valor * this.dados.quantidade),
          items: [{
            item_id: this.dados.produto.id_tabela_preco,
            item_name: this.produto.nome_produto,
            quantity: this.dados.quantidade
          }]
        });
      },

      closeProduto(confirm) {
        if (confirm && this.step > 0 && this.produto.adicionais.length) {
          this.$swal({
            text: 'Deseja voltar? Este produto não será adicionado ao seu pedido.',
            buttons: ["Não", "Sim"],
            dangerMode: true,
          }).then((r) => {
            if (r) {
              document.body.classList.remove("modal-open");
              this.aberto = false;
              this.animateCSS('sacolaAnimated', 'bounceIn')

              if (!this.isComponente) {
                const id_categoria = this.categoria ? this.categoria.id_categoria : null
                window.history.replaceState(null, null, `${window.location.pathname}?id=${id_categoria}`);
              }
            }
          });

        } else {
          document.body.classList.remove("modal-open");
          this.aberto = false;
          this.animateCSS('sacolaAnimated', 'bounceIn')

          if (!this.isComponente) {
            const id_categoria = this.categoria ? this.categoria.id_categoria : null
            window.history.replaceState(null, null, `${window.location.pathname}?id=${id_categoria}`);
          }
        }
      },

      animateCSS(element, animationName, callback) {
        const node = document.getElementById(element);

        if (node) {
          node.classList.add('animated', animationName);

          function handleAnimationEnd() {
            node.classList.remove('animated', animationName);
            node.removeEventListener('animationend', handleAnimationEnd);

            if (typeof callback === 'function') callback()
          }

          node.addEventListener('animationend', handleAnimationEnd)
        }
      },

      previusStep() {
        this.avancar = false;

        if (this.step > 0) {
          const step = (this.step === 2 && this.produto.divisao === '0' ? 0 : (this.step - 1));
          const index = (step - 2);
          this.step = 9999;

          setTimeout(() => {
            this.step = step;

            this.$nextTick(() => {
              if (this.step === 0 && (this.produto.tabelas.length === 1 || this.fixo)) {
                this.$emit('retorno');
                this.closeProduto();
                return;

              } else if (index >= 0 && this.produto.adicionais.length > index) {
                const g = this.produto.adicionais[index];

                if (g) {
                  this.searchAdicional = g.itens;
                }
              }

              this.scrollTop();
            });
          }, 100);

        } else {
          this.$emit('retorno');
          this.closeProduto();
        }
      },

      avancarAutomatico(texto) {
        if (this.avancar) {
          this.$store.state.load = texto || "Avançando..";
          setTimeout(() => {
            this.$store.state.load = false;
            this.nextStep(true);
          }, 500);
        }
      },

      nextStep(scroll) {
        if (this.btnAvancar < this.step || this.step >= this.maxStep) {
          return;
        }

        this.avancar = true;
        this.termAdd = "";
        const step = (this.step === 0 && this.produto.divisao === '0' ? 2 : (this.step + 1));
        const index = (step - 2);

        setTimeout(() => {
          this.step = step;
          this.$nextTick(() => {
            if (index >= 0 && this.produto.adicionais.length > index) {
              const g = this.produto.adicionais[index];

              if (g) {
                this.searchAdicional = g.itens;
                this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));
              }
            }
          });

          if (this.step === this.maxStep && this.dados.adicionais.length) {
            this.dados.adicionais = this.dados.adicionais.sort((a, b) => a.index - b.index);
          }

          if (scroll) {
            this.scrollTop();
          }
        }, 100);
      },

      scrollTop() {
        if (window.innerWidth > 768) {
          const container = document.querySelector('.container-produto');

          if (container) {
            container.scrollTo({ top: 0 });
          }

        } else {
          this.$helpers.scrollTo('containerProduto');
        }
      },

      getStatusEmpresa() {
        if (!this.empresaAberta && !sessionStorage.getItem('restauranteFechado')) {
          this.$swal("Desculpe, não estamos atendendo no momento! Sinta-se à vontade para conferir nossos produtos.");
          sessionStorage.setItem('restauranteFechado','true');
        }
      },

      openProduto(dados) {
        if (!this.isComponente) {
          const url = `${window.location.pathname}?id=${dados.id_categoria || ''}&produto=${dados.id}`;
          window.history.replaceState(null, null, url);
        }

        this.getStatusEmpresa();
        this.getProduto(dados.id, dados.id_tabela);
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      }
    }
  }
</script>

<style scoped>
  .btn.btn-bottom {
    min-height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-check {
    padding-right: 12px;
  }

  .produto-divisao-restricoes {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
    margin-top: 4px;
  }

  .modal-produto {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    overflow: auto;
  }

  /* Modal Content/Box */
  .modal-produto-content {
    width: 100%;
    background-color: #fefefe;
  }

  .header-produto {
    position:fixed;
    right:0;
    top:0;
    left:0;
    z-index:1030;
  }

  .add-sacola {
    bottom: env(safe-area-inset-bottom, 10px);
    position:fixed;
    right:0;
    left:0;
    z-index:1030;
    padding: 0.5rem 15px;
    background-color: #ffffff;
  }

  .ios_platform .add-sacola {
    padding-bottom: 32px;
  }

  .container-produto {
    padding: 68px 0 156px;
    min-height: 100vh;
    overflow: auto;
  }

  .produto-disable {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .produto-selecionado {
    color: var(--lecard-primary);
  }



  .topbar-produto {
    height: 76px;
    display: flex;
    align-items: center;
  }

  .lista-produto-item {
    padding: 10px 4px;
    display: flex;
    align-items: center;
    min-height: 86px;
  }

  .lista-produto-item img {
    width: 52px;
    height: 52px;
    object-fit: cover;
    border-radius: 4px;
  }

  @media (min-width: 768px) {
    .modal-produto-content {
      margin: 15px auto;
      width: 768px;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
    }

    .header-produto {
      position: static;
    }

    .add-sacola {
      position: static;
      padding: 12px;
    }

    .container-produto {
      overflow: auto;
      min-height: auto;
      height: calc(90vh - 130px);
      padding: 0 0 12px 0;
      /*scrollbar-width: none;*/
    }

    .container-produto::-webkit-scrollbar {
      /*display: none;*/
    }

    .topbar-produto {
      position: static!important;
    }
  }
</style>
